module.exports = __webpack_public_path__ + "static/media/loader-logo.57468677.svg";